import React from "react";
import Layout from "../Layout";
import AnalyticsContainer from "../containers/Analytics";

export default function AnalyticsPage() {
  return (
    <Layout>
      <AnalyticsContainer />
    </Layout>
  );
}

